import _ from 'lodash';
import { extendMoment } from 'moment-range';
import { TextField } from 'material-ui';
import Moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import OurismanTravelTheme from '../../ourismanTravelTheme';

const moment = extendMoment(Moment);

const Rate = ({ rate, currency, index, editing, onChange }) => {
  const dayNumber = index + 1;

  const displayRate = rate ? rate.toFixed(2) : 'n/a';

  return (<div style={styles.rate}>
    <div style={styles.rateHeader}>Day {dayNumber}</div>
    <div>{editing ? <TextField
      id={`rate${index}`}
      value={rate}
      type='number'
      onChange={onChange}
    /> : displayRate}</div>
    {editing ? null : <div style={styles.rateHeader}>{currency}</div>}
  </div>);
};

Rate.propTypes = {
  rate: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  editing: PropTypes.bool,
  onChange: PropTypes.func,
};

Rate.defaultProps = {
  editing: false,
  onChange: null,
};

export default class DailyRates extends React.Component {
  static propTypes = {
    rates: PropTypes.arrayOf(PropTypes.number),
    currency: PropTypes.string.isRequired,
    average: PropTypes.number.isRequired,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    editing: PropTypes.bool.isRequired,
  }

  static defaultProps = {
    rates: [],
  }

  constructor(props) {
    super(props);

    const { rates, currency, average, startDate, endDate } = this.props;

    const averageRate = !average && rates.length ? this.average(rates) : rates[0] || 0;

    this.state = {
      rates,
      currency,
      average,
      averageRate,
      slicedRates: this.sliceRates(rates, startDate, endDate),
    };
  }

  setAverageRate = (e) => {
    const { target: { value } } = e;
    const { onChange } = this.props;
    const averageRate = parseFloat(value);

    const { rates, slicedRates, currency } = this.state;
    const parsedValue = parseFloat(value);
    rates.fill(parsedValue);
    slicedRates.fill(parsedValue);
    onChange(slicedRates, currency);

    this.setState({
      averageRate,
      rates,
      slicedRates,
    });
  }

  toggleAverage = () => {
    this.setState({ average: !this.state.average });
  }

  updateRate = index => (e) => {
    const { target: { value } } = e;
    const { onChange } = this.props;

    const { rates, slicedRates, currency } = this.state;
    const newRates = [...rates];
    const newSliced = [...slicedRates];

    newRates[index] = parseFloat(value);
    newSliced[index] = parseFloat(value);
    onChange(newSliced, currency);

    this.setState({
      rates: newRates,
      averageRate: this.average(rates),
    });
  }

  average = (rates) => {
    if (rates.length === 0) {
      return 0;
    }
    return rates.reduce((a, b) => a + b) / rates.length;
  }

  componentWillReceiveProps(nextProps) {
    const { startDate, endDate, rates = [], average } = nextProps;
    const slicedRates = this.sliceRates(rates, startDate, endDate);
    const averageRate = this.average(slicedRates);
    this.setState({
      rates,
      slicedRates,
      averageRate,
      average,
    });
  }

  sliceRates = (rates, startDate, endDate) => {
    const momentStartDate = moment(startDate);
    const momentEndDate = moment(endDate);
    const duration = moment.range(momentStartDate, momentEndDate).diff('days');
    const slicedRates = rates.slice(0, duration);

    while (slicedRates.length < duration) {
      slicedRates.push(0);
    }

    return slicedRates;
  }

  updateCurrency = (e) => {
    const { target: { value } } = e;
    const { onChange } = this.props;
    const { slicedRates } = this.state;

    this.setState({
      currency: value,
    });
    onChange(slicedRates, value);
  }

  render() {
    const { editing } = this.props;
    const { rates, currency, average, slicedRates } = this.state;

    const averageRate = this.average(rates);
    let formattedRate = 'n/a';
    if (!_.some(rates, x => x === null)) {
      formattedRate = averageRate.toFixed(2);
    }

    const display = (<div>
      <h4>Average Daily Rate: {currency} {formattedRate}</h4>
      <div style={styles.rates}>
        {rates.map((rate, index) => <Rate
          rate={rate}
          currency={currency}
          key={index}
          index={index}
        />)}
      </div>
    </div>);

    const edit = (<div>
      <h4>
        Average Daily Rate:<br />
        <TextField
          type='number'
          onChange={this.setAverageRate}
          value={averageRate}
          disabled={!average}
        /><br />
        <TextField
          floatingLabelText='Currency'
          value={currency}
          onChange={this.updateCurrency}
        />
      </h4>
      {average ? null : <div style={styles.rates}>
        {slicedRates.map((rate, index) => <Rate
          editing
          rate={rate}
          currency={currency}
          key={index}
          index={index}
          onChange={this.updateRate(index)}
        />)}
      </div>}
    </div>);

    return editing ? edit : display;
  }
}

const styles = {
  rates: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
  },
  rate: {
    padding: 5,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  rateHeader: {
    width: '100%',
    textAlign: 'center',
    padding: 3,
    background: OurismanTravelTheme.palette.primary3Color,
  },
};



// WEBPACK FOOTER //
// /src/components/Trips/DailyRates.js